import * as React from "react";
import type { CarouselContextProps } from "../components/Carousel/types";

const defaultContext: CarouselContextProps = {
  carouselRef: null,
  api: null,
  orientation: "horizontal",
  scrollPrev: () => {},
  scrollNext: () => {},
  canScrollPrev: false,
  canScrollNext: false,
};

const CarouselContext =
  React.createContext<CarouselContextProps>(defaultContext);

export function useCarousel() {
  const context = React.useContext(CarouselContext);
  return context;
}

export { CarouselContext };
